<template>
  <div class="container">
    <div class="top_title">课程资料</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="selection_condition_title" style="margin-top: 2.6rem">
        <span class="icon_selection_condition"></span>
        <span>筛选条件</span>
      </div>
      <div class="selection_items">
        <div class="weui-cells item">
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>校区</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="currentSchool">
                <option value=''>请选择</option>
                <option v-for="school in schoolList" :value='school.I_SCHOOL_NO'>{{school.I_SCHOOL_NAME}}</option>
              </select>
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>班级</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="currentClass">
                <option value=''>请选择</option>
                <option v-for="item in classList" :value='item.I_CLASS_NO'>{{item.I_CLASS_NAME}}</option>
              </select>
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>日期范围</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="I_DATE">
                <option value=''>请选择</option>
                <option value='近一周'>近一周</option>
                <option value='近一个月'>近一个月</option>
                <option value='全部'>全部</option>
              </select>
            </div>
          </div>
          <button class="bottom_btn" @click="searchCourse">查询</button>
        </div>
      </div>

      <div v-if="info.dataCount != '0'" class="curriculum_records_title">
        <span class="icon_curriculum_records"></span>
        <span>课程记录</span>
      </div>
      <div v-if="info.dataCount != '0'" class="curriculum_records">
        <div class="weui-cells item">
          <div v-for="item in info.dataList" tag="div" :key="item.id" @click="clickCourse(item)"
                       class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>{{item.I_SHOW_INFO}}</p>
            </div>
            <div class="weui-cell__ft">
              <input type="text" class="input_text" disabled :value="item.I_REAL_DATE"/>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        schoolList: [],
        currentSchool: "",
        classList: [],
        currentClass: "",
        I_DATE:"近一个月",
        info: {
          dataCount: "0",
          dataList:[]
        }
      }
    },
    components: {
      Footer
    },
    created() {
      let vm = this
      DataRequestFactory.C010010().then((response) => {
        vm.schoolList = response.dataList

        let pageNo = vm.$route.params.pageNo
        if(pageNo && pageNo == 'H060020') {
          if(window.localStorage.getItem("H060010Info")) {
            let H060010Info = JSON.parse(window.localStorage.getItem("H060010Info"))
            vm.currentSchool = H060010Info.I_SCHOOL_NO
            vm.currentClass = H060010Info.I_CLASS_NO
            vm.I_DATE = H060010Info.I_DATE

            vm.searchCourse();
          }
        } else {
          if(vm.schoolList.length == 1) {
            vm.currentSchool = vm.schoolList[0].I_SCHOOL_NO
          }
        }
    })
    },
    methods: {
      clickCourse(item) {
        let localH060010 = {
          I_SCHOOL_NO: this.currentSchool,
          I_CLASS_NO: this.currentClass,
          I_DATE: this.I_DATE
        }
        window.localStorage.setItem("H060010Info",JSON.stringify(localH060010))

        let H060010Info = {
          I_SCHOOL_NO: this.currentSchool,
          I_CLASS_NO: this.currentClass,
          I_DATE: item.I_REAL_DATE
        }
        this.$router.push({name:'H060020', params: {info: JSON.stringify(H060010Info)}})
      },
      searchCourse() {
        let params = {
          I_SCHOOL_NO: this.currentSchool,
          I_CLASS_NO: this.currentClass,
          I_DATE: this.I_DATE
        }

        DataRequestFactory.I060010(params).then((response) => {
          this.info = response
      })
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 0
      $(".scroll_area").css("height", heightDiff + "px"   )
    },
    watch: {
      currentSchool (val) {
        if(val == "") {
          this.classList = []
        } else {
          let param = {
            I_SCHOOL_NO: val
          }
          DataRequestFactory.C010011(param).then((response) => {
              this.classList = response.dataList
              if(this.classList.length == 1) {
                this.currentClass = this.classList[0].I_CLASS_NO
                this.searchCourse()
              }
          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H060010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H060010.vue